import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationDeleteLeadStatus(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<unknown, unknown, { columnId: number }>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ columnId }: { columnId: number }) =>
      api.leadApi.deleteStatusColumn(columnId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
    },
    ...mutationOpts,
  });
}
